import {ProductApi, TagDto} from "../../../api";
import {CrudFormItemProps, CrudFormModal} from "digimuth-components/dist";
import {useInjection} from "inversify-react";
import ApiService from "../../../services/apiService";
import {useParams} from "react-router-dom";
import {Select} from "antd";

const {Option} = Select;

export default function ExistingTagsModalForm(props: TagModalProps) {




    const formItems: CrudFormItemProps[] = [
        {
            label: "Tagi",
            name: "tagsIds",
            rules: [
                {required: true, message: 'This field is required'}
            ],
            children: <Select mode={"multiple"}>
                {props.allTags?.map(tag => (
                    <Option key={tag.id} value={tag.id}>{tag.value}</Option>
                ))}
            </Select>
        },
    ];

    return <CrudFormModal
        formItems={formItems}
        forceRender={true}
        destroyOnClose={true}
        onSubmit={props.onSubmit}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        modalOkText={props.saveButtonTitle}
        modalCancelText={props.cancelButtonTitle}
        modalTitle={props.modalTitle}
        isModalVisible={props.isModalVisible}
    />;
}

interface TagModalProps {
    isModalVisible: boolean;
    setModalVisibility: (isVisible: boolean) => any;
    modalTitle: string,
    saveButtonTitle: string,
    cancelButtonTitle: string;
    allTags: TagDto[] | null;
    onSubmit: any;
}
